import React from 'react';
import CardHeader from '../../Components/Card/CardHeader';
import $ from 'jquery';
import 'jquery-confirm';
import * as _ from 'lodash';
import { api } from 'axiosConfig';

export default function TopHeading(props) {
    const dialogCloseFunc = (dialoge) => {
        dialoge.close();
        return true;
    }
    const getUserDetFunc = async (dialoge, type) => {
        const url2 = process.env.REACT_APP_BASE_URL_API + '/api/v1/auth/user/get-user/' + props.userID;
        await api.post(url2, {})
            .then((res) => {
                props.setProfileData(_.get(res, 'data', {}));
                $.alert(`You ${type} Successfully`, dialogCloseFunc(dialoge));
            })
            .catch((err) => {
                props.setError(true);
                console.log(err);
            });
    }
    const unSubscriptionService = async (dialoge, type) => {
        const url = process.env.REACT_APP_BASE_URL_API + '/api/v1/auth/user/unSubscribeUser/' + props.userID;
        await api.post(url, {})
            .then(async (res) => {
                getUserDetFunc(dialoge, type);
                // Hey! sonarqube, Please ignore this code
                // const url2 = process.env.REACT_APP_BASE_URL_API + '/api/v1/auth/user/get-user/' + props.userID;
                // await api.post(url2, {})
                //     .then((res) => {
                //         props.setProfileData(_.get(res, 'data', {}));
                //         $.alert(`You ${type} Successfully`, function () {
                //             dialoge.close()
                //         });
                //     })
                //     .catch((err) => {
                //         props.setError(true);
                //         console.log(err);
                //     });
            })
            .catch((err) => {
                props.setError(true);
                console.log(err);
            });
    }
    const unsubscribe = (type) => {
        $.confirm({
            title: 'Confirm!',
            content: `Are you sure, You want to ${type}?`,
            buttons: {
                confirm: function () {
                    let dialoge = $.dialog({
                        title: 'Please wait..!',
                        content: `Please wait, While we ${type} you!`,
                    });
                    unSubscriptionService(dialoge, type);
                },
                cancel: function () {

                }
            }
        });
    }

    const deleteRespoFunc = async (dialoge) => {
        const url2 = process.env.REACT_APP_BASE_URL_API + '/api/v1/auth/user/get-user/' + props.userID;
        await api.post(url2, {})
            .then((res) => {
                props.setProfileData(_.get(res, 'data', {}));
                $.alert(`Successfully Deleted`, dialogCloseFunc(dialoge));
            })
            .catch((err) => {
                props.setError(true);
                console.log(err);
            });
    }

    const permanentlyDeleted = async (dialoge) => {
        const url = process.env.REACT_APP_BASE_URL_API + '/api/v1/auth/user/permanentlyDelete/' + props.userID + '/admin';
        await api.post(url, {})
            .then(async (res) => {
                deleteRespoFunc(dialoge);
                // Hey! sonarqube, Please ignore this code
                // const url2 = process.env.REACT_APP_BASE_URL_API + '/api/v1/auth/user/get-user/' + props.userID;
                // await api.post(url2, {})
                //     .then((res) => {
                //         props.setProfileData(_.get(res, 'data', {}));
                //         $.alert(`Successfully Deleted`, function () {
                //             dialoge.close()
                //         });
                //     })
                //     .catch((err) => {
                //         props.setError(true);
                //         console.log(err);
                //     });
            })
            .catch((err) => {
                $.alert("Something went wrong, please try again later");
                console.error(err);
            });
    }
    const permanentlyDelete = (type) => {
        $.confirm({
            title: 'Confirm!',
            content: `Are you sure, You want to permanently delete?`,
            buttons: {
                confirm: function () {
                    let dialoge = $.dialog({
                        title: 'Please wait..!',
                        content: `Please wait, While we permanently deleting!`,
                    });
                    permanentlyDeleted(dialoge);
                },
                cancel: function () {
                }
            }
        });
    }
    const changePasswordService = async (newPassword, dialoge) => {
        const data = {
            userId: props.userID,
            password: newPassword
        };
        const url = process.env.REACT_APP_BASE_URL_API + '/api/v1/auth/user/change-password';
        await api.post(url, data)
            .then((res) => {
                $.alert("Password Changed Successfully", dialogCloseFunc(dialoge));
            })
            .catch((err) => {
                $.alert("Something went wrong, please try again later");
                console.error(err)
            });
    }

    const changePassword = () => {
        $.confirm({
            title: 'Change Password',
            content: '' +
                '<form action="" class="changePasswordForm">' +
                '<div class="form-group">' +
                '<label for="newPassword">New Password:</label>' +
                '<input type="password" id="newPassword" class="newPassword form-control" required />' +
                '</div>' +
                '<div class="form-group">' +
                '<label for="confirmPassword">Confirm Password:</label>' +
                '<input type="password" id="confirmPassword" class="confirmPassword form-control" required />' +
                '</div>' +
                '</form>',
            buttons: {
                formSubmit: {
                    text: 'Change Password',
                    btnClass: 'btn-blue',
                    action: function (this: any) {
                        // eslint-disable-next-line react/no-this-in-sfc
                        let newPassword = this.$content.find('.newPassword').val();
                        // eslint-disable-next-line react/no-this-in-sfc
                        let confirmPassword = this.$content.find('.confirmPassword').val();
                        if (newPassword !== confirmPassword) {
                            $.alert('New password and confirm password do not match.');
                            return false;
                        } else {
                            let dialoge = $.dialog({
                                title: 'Please wait..!',
                                content: 'Please wait, While we are changing the password!',
                            });
                            changePasswordService(newPassword, dialoge);
                        }
                    }
                },
                cancel: function () {
                },
            },
            onContentReady: function () {
                let jc = this;
                // eslint-disable-next-line react/no-this-in-sfc
                this.$content.find('.changePasswordForm').on('submit', function (e) {
                    e.preventDefault();
                    jc.$$formSubmit.trigger('click');
                });
            }
        });
    }

    return <div className='w-100 mb-3'>
        <CardHeader color="primary">
            <div className="d-flex align-items-center justify-content-between">
                <h4>Panelist Details</h4>
                <span className="align-items-right">
                    {props?.profileData?.length !== 0 && props?.profileData?.data.dataValues.unsubscribeDate === null ?
                        <button type="button" className="btn btn-info" onClick={() => unsubscribe('unsubscribe')}>Unubscribe </button>
                        :
                        <button type="button" className="btn btn-info" onClick={() => unsubscribe('Subscribe')}>Subscribe</button>
                    }
                    <button type="button" className="btn btn-blue ml-1" onClick={changePassword}>Change Password</button>
                    <button type="button" className="btn btn-red ml-1" onClick={permanentlyDelete}>Permanently Deleted</button>
                </span>
            </div>
        </CardHeader>
    </div>
}